import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function isValidURL(str) {
  const pattern = new RegExp(
    "((?:www.|(?!www))" +
      "[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]." +
      "[^s]{2,}|www.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]." +
      "[^s]{2,}|https?://(?:www.|(?!www))[a-zA-Z0-9]+." +
      "[^s]{2,}|www.[a-zA-Z0-9]+.[^s]{2,})",
    "i"
  );
  return !!pattern.test(str);
}

export function isEmailValid(str) {
  const regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !!regex.test(str);
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
